import { get } from "lodash";
import queryString from "query-string";
import React, { useState } from "react";
import {
	Button,
	Confirm,
	useCreate,
	useNotify,
	useRefresh,
	useTranslate,
} from "react-admin";
import { useHistory } from "react-router-dom";
import { UserWtrIcon } from "../../icons";

const getYear = () => {
	const year = new Date().getFullYear();
	const month = new Date().getMonth();
	if (month === 1) {
		return year - 1;
	}
	return year;
};

const RequestButton = (props) => {
	const history = useHistory();
	const search = get(history, "location.search");
	const filter = get(queryString.parse(search), "filter", "{}");
	const request = get(JSON.parse(filter), "request") !== undefined;
	const year = getYear();
	const translate = useTranslate();
	const notify = useNotify();
	const refresh = useRefresh();
	const [open, setOpen] = useState(request);
	const handleDialogClose = () => setOpen(false);
	const handleClick = () => setOpen(true);
	const [create, { loading }] = useCreate(
		"user-wtrs",
		{},
		{
			onSuccess: () => {
				notify("resources.user-wtrs.actions.request.success");
				refresh();
			},
		}
	);
	const handleConfirm = () => {
		create();
		setOpen(false);
	};
	return (
		<>
			<Button
				label="resources.user-wtrs.actions.request.button"
				disabled={loading}
				onClick={handleClick}
				disableElevation
			>
				<UserWtrIcon />
			</Button>
			<Confirm
				isOpen={open}
				loading={loading}
				title={translate("resources.user-wtrs.actions.request.title", {
					year,
				})}
				content={translate("resources.user-wtrs.actions.request.content", {
					year,
				})}
				onConfirm={handleConfirm}
				onClose={handleDialogClose}
			/>
		</>
	);
};

export default RequestButton;
